// removed by extract-text-webpack-plugin
module.exports = {"nf-solicitation_grid_header-tooltip":"nf-solicitation_grid_header-tooltip"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/universalDetails/niinDetailTables/subcomponents/Header/Header.scss
// module id = 4973
// module chunks = 1